import { useEffect } from 'react';
import triggerGoogleTagManagerCustomEvent from '../../common/utils/triggerGoogleTagManagerCustomEvent';
import GtmEvents from '../constants/gtmEvents';
import findAssociatedLabel from '../utils/findAssociatedLabel';

function useGtmToggleChangeTracking() {
  useEffect(() => {
    const handleChange = (e: Event) => {
      // Check if target is an Element (covers both HTMLElement and SVGElement)
      // This is important because clicking on icons/SVGs inside buttons should still track the button
      if (!(e.target instanceof Element)) {
        return;
      }

      const toggleElement = e.target.closest('button[role="switch"], div[role="switch"]');

      if (toggleElement instanceof HTMLElement) {
        const label = findAssociatedLabel(toggleElement);

        triggerGoogleTagManagerCustomEvent(GtmEvents.TOGGLE_CLICK, {
          action: 'change',
          label,
          new_state: toggleElement.getAttribute('aria-checked') === 'true' ? 'enabled' : 'disabled',
        });
      }
    };

    document.addEventListener('change', handleChange, { capture: true });
    return () => document.removeEventListener('change', handleChange, { capture: true });
  }, []);
}

export default useGtmToggleChangeTracking;
